import styled from "styled-components";

export const MainContainerWrapper = styled.div`
  margin-top: 16px;
  margin-right: 16px;
  width: 100%;

  @media screen and (max-width: 1245px) {
    margin-right: 0;
  }
`;
